import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import { IEGridItemModel, IEGridItemModelDTO } from "./IEGridItemModel";

export class IEGridSubcategoryModel extends ModelBase<IEGridSubcategoryModel, IEGridSubcategoryModelDTO> {
    public id: string = "";
    public createdDate: string = "";
    public sourceId: number = 0;
    public parentId: string | null = null;

    @MobX.observable
    public name: string = "";

    @MobX.observable
    public income: number = 0;

    @MobX.observable
    public estimateCost: number = 0;

    @MobX.observable
    public estimatedMargin: number = 0;

    @MobX.observable
    public futureSpend: number = 0;

    @MobX.observable
    public targetCost: number = 0;

    @MobX.observable
    public committedCost: number = 0;

    @MobX.observable
    public totalExpectedSpend: number = 0;

    @MobX.observable
    public variance: number = 0;

    @MobX.observable
    public changePeriod: number = 0;

    @MobX.observable
    public margin: number = 0;

    @MobX.observable
    public roValue: number = 0;

    @MobX.observable
    public gridItems: IEGridItemModel[] = [];

    @MobX.computed
    public get getGridItems(): IEGridItemModel[] {
        const sortedGridItems: IEGridItemModel[] = this.gridItems.slice().sort((a, b) => a.getName().localeCompare(b.getName()));

        return sortedGridItems;
    }

    fromDto(model: IEGridSubcategoryModelDTO): void {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else if (key === "gridItems") {
                    let items: IEGridItemModel[] = [];
                    model[key].forEach((element) => {
                        let newModel = new IEGridItemModel();
                        newModel.fromDto(element);
                        items.push(newModel);
                    });
                    this.gridItems = items;
                } else {
                    this[key] = model[key];
                }
            }
        }
    }

    toDto(model: IEGridSubcategoryModel): void {}
}

export type IEGridSubcategoryModelDTO = {
    id: string;
    name: string;
    sourceId: number;
    createdDate: string;
    income: number;
    estimateCost: number;
    estimatedMargin: number;
    futureSpend: number;
    targetCost: number;
    committedCost: number;
    totalExpectedSpend: number;
    variance: number;
    changePeriod: number;
    margin: number;
    roValue: number;
    gridItems: IEGridItemModelDTO[];
};
